import exact from 'prop-types-exact';
import PropTypes from 'prop-types';
import React from 'react';

import Image from '../Atoms/Image';

const propTypes = exact({
  image: PropTypes.object.isRequired,
});

function ImageBlock(props) {
  return (
    <div className="ImageBlock">
      <div className="ImageBlock_content">
        <figure className="ImageBlock_body">
          <Image {...props.image} useAspectRatio />
        </figure>
      </div>
    </div>
  );
}

ImageBlock.propTypes = propTypes;

export default ImageBlock;
